module.exports = __webpack_public_path__ + "static/media/sowrya.f6489694.jpg";